import { SeasonsGridView } from '~/components/catalog/seasons';
import { PageContainer } from '~/components/page-container';

export function Seasons() {
	return (
		<PageContainer>
			<SeasonsGridView />
		</PageContainer>
	);
}
